import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

// One left-swipe gesture: fade in on the right, glide left, fade out.
const swipe = keyframes`
  0%   { transform: translateX(60px);  opacity: 0; }
  20%  { opacity: 1; }
  80%  { opacity: 1; }
  100% { transform: translateX(-60px); opacity: 0; }
`;

// Overlay centered on the opened carousel image. pointer-events:none so it never
// intercepts the drag it is hinting at.
const HintLayer = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Hand = styled.div`
  width: 96px;
  height: 96px;
  color: #ffffff;
  filter: drop-shadow(0 3px 10px rgba(0, 0, 0, 0.65));
  /* 2 iterations x 1s = the 2s hint window. */
  animation: ${swipe} 1s ease-in-out 2;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

// Shows a hand icon swiping left for ~2s when `active` turns true, telling the
// user they can drag the image left to the next one. Only fires when there is
// more than one image to swipe to.
const DragHint = ({ active, imageCount = 0 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (active && imageCount > 1) {
      setShow(true);
      const t = setTimeout(() => setShow(false), 2000);
      return () => clearTimeout(t);
    }
    setShow(false);
  }, [active, imageCount]);

  if (!show) return null;

  return (
    <HintLayer>
      <Hand>
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.44-.72c-.33-.07-.68.04-.91.29l-.75.8 4.4 4.4c.27.27.63.42 1.01.42h6.41c.75 0 1.38-.55 1.49-1.29l.74-5.18c.11-.72-.27-1.42-.93-1.75z" />
        </svg>
      </Hand>
    </HintLayer>
  );
};

export default DragHint;
